import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import api from "@/lib/api";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState({ status: "checking", payment_status: "pending" });
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sessionId) { setState({ status: "error", payment_status: "no_session" }); return; }
    let alive = true;
    const poll = async (n) => {
      try {
        const r = await api.get(`/checkout/status/${sessionId}`);
        if (!alive) return;
        setState(r.data);
        if (r.data.payment_status === "paid") return;
        if (r.data.status === "expired") return;
        if (n >= 8) return;
        setAttempts(n + 1);
        setTimeout(() => poll(n + 1), 2000);
      } catch {
        if (!alive) return;
        setState({ status: "error", payment_status: "error" });
      }
    };
    poll(0);
    return () => { alive = false; };
  }, [sessionId]);

  const paid = state.payment_status === "paid";
  const failed = state.status === "expired" || state.payment_status === "error" || state.payment_status === "no_session";

  return (
    <>
      <Header />
      <main className="pt-36 sm:pt-40 pb-20 min-h-screen bg-[#FAFAFA]" data-testid="payment-success-page">
        <div className="max-w-2xl mx-auto px-4 text-center">
          <div className="bg-white rounded-3xl border border-black/8 p-10">
            {paid ? (
              <>
                <CheckCircle2 size={64} className="text-[#06B6D4] mx-auto" />
                <h1 className="display mt-5 text-3xl text-[#0A1128]">Paiement confirmé !</h1>
                <p className="mt-3 text-[#475569]">Votre RDV conseil 1h en visio est réservé. Vous recevrez un email de confirmation avec le lien de visio.</p>
              </>
            ) : failed ? (
              <>
                <XCircle size={64} className="text-red-500 mx-auto" />
                <h1 className="display mt-5 text-3xl text-[#0A1128]">Paiement non confirmé</h1>
                <p className="mt-3 text-[#475569]">Si vous avez été débité, contactez-nous à contact@besson-solutions.fr.</p>
              </>
            ) : (
              <>
                <Loader2 size={48} className="animate-spin text-[#06B6D4] mx-auto" />
                <h1 className="display mt-5 text-2xl text-[#0A1128]">Vérification en cours...</h1>
                <p className="mt-2 text-[#475569] text-sm">Tentative {attempts + 1} / 9</p>
              </>
            )}
            <Link to="/" data-testid="payment-back-home" className="mt-7 inline-block px-6 py-3 rounded-full bg-[#0A1128] text-white font-semibold">Retour à l'accueil</Link>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
